import { X } from "lucide-react";
import React, { useContext } from "react";
import Tooltip from "../../../Tooltip";
import { ToastContext } from "../../ToastProvider";
import { BaseCloseIconButton } from "./styled";
import { jsx as _jsx } from "react/jsx-runtime";
function CloseIconButton(_ref) {
  var onClose = _ref.onClose;
  var type = useContext(ToastContext);
  return /*#__PURE__*/_jsx(Tooltip, {
    content: "Close",
    children: /*#__PURE__*/_jsx(BaseCloseIconButton, {
      type: type,
      onClick: onClose,
      children: /*#__PURE__*/_jsx(X, {
        size: "1rem",
        color: "currentColor"
      })
    })
  });
}
export default CloseIconButton;